import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Translate, I18n } from 'react-redux-i18n';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb, Input, Dropdown, MenuItem } from 'react-bootstrap';
import axios from 'axios';
import Select from 'react-select';
import { debounce } from 'lodash';
import ReactPaginate from 'react-paginate';

import SpinnerButton from '../Common/SpinnerButton';
import GenericSelection from '../Common/GenericSelection';
import Spinner from '../Widgets/spinner';

import { APP_COLORS, BACKGROUND_COLOR, UI_HEIGHT } from '../../components/Common/constants';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import checkPermission from '../Common/permissions';
import FilterByStart from '../Common/filterByStart';
import FilterMultiKeyword from '../Common/filterMultiKeyword';
import { productUpload, productUpload2, productUploadGFD } from '../../actions/products_actions';
import { BASE_USER_URL } from '../../actions/url';
import { ROOT_URL, ROOT_API_URL, companyCodeTitle, isJRC, isHO, isSKH, isGFD, isOLG,
  isABCFF, isSW, isGGI, isVAK, isSV, isSH, isAP, isAGD, isCRW, isSC, isUSPrideMulti
} from '../../actions/root_url';
import { fileDownload } from '../../utils';

const isMyuMyu = ROOT_API_URL === 'https://mmstage-scm.truckxi.com/api/' || ROOT_API_URL === 'https://myumyu-scm.truckxi.com/api/';
const isAFG = ROOT_API_URL === 'https://afg-scm.truckxi.com/api/' || ROOT_URL === 'https://afg-scm.truckxi.com/api/';
const isWecom = ROOT_API_URL === 'https://wecom-scm.truckxi.com/api/' || ROOT_API_URL === 'https://wecom-scm.truckxi.com/api/';
const isTN =
  ROOT_API_URL === "https://tn-scm.truckxi.com/api/" ||
  ROOT_URL === "https://tn-scm.truckxi.com/api/";
const isWIZ = ROOT_API_URL === 'https://wiz-scm.truckxi.com/api/' || ROOT_URL === 'https://wiz-scm.truckxi.com/api/';

class RowRenderer extends Component {
  getRowStyle() {
    return {
      color: this.getRowBackground(),
    };
  }

  getRowBackground() {
    return this.props.row.IsStopSale === 'yes' ? BACKGROUND_COLOR.red : 'black';
  }

  render() {
    // here we are just changing the style
    // but we could replace this with anything we liked, cards, images, etc
    // usually though it will just be a matter of wrapping a div, and then calling back through to the grid
    return (
      <div
        style={this.getRowStyle()}
        onDoubleClick={() => { this.props.onDoubleClick(this.props.row); }}
      >
        <ReactDataGrid.Row ref="row" {...this.props} />
      </div>
    );
  }
}

RowRenderer.PropTypes = {
  onDoubleClick: React.PropTypes.func,
};

class Products extends Component {
  static contextTypes = {
    router: React.PropTypes.object
  };

  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton,

      // React Data Grid states
      rows: [],
      selectedRows: [],
      filters: {},
      searchFilters: {},
      sortColumn: null,
      sortDirection: null,
      currentDep: -1,
      currentGroup: null,
      currentCategory: -1,
      groupExpanded: false,
      depExpanded: false,
      clear: true,
      files: null,
      selectedRowsIdx: null,
      quickEntryProductNum: '',
      quickEntryShowError: false,

      searchType: null,
      isDiscontinued: (isSH || isAP) ? 0 : null,
      lowerRange: null,
      upperRange: null,
      printQty: null,
      printHasPrice: false,

      buyerOptions: [],
      selectedBuyer: 'All',
      currentPage: 0,
      limitDisplay: 30,
      limit: 30,
      productImportLoading: false,
      isGFDExportLoading: false,
    };

    this.handleResize = this.handleResize.bind(this);
    this.checkDetail = this.checkDetail.bind(this);
  }

  componentWillMount() {
    this.props.resetGroupAndCategory();
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    window.addEventListener('resize', this.handleResize);

    let buyerOptions = [{value: "All", label: "All Buyers"}];
    if ((isGFD && true)) {
      this.props.fetchDeps();

      axios.get(
        `${BASE_USER_URL}users/?Company_id=${this.props.selectedCompany && this.props.selectedCompany.value}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        },
      )
      .then(res => {
        res && res.data && res.data.map((r,i) => {
          buyerOptions.push({label: r.username, value: r.BaseUser_id});
        });
        this.setState({ buyerOptions, selectedBuyer: 'All' });
      }, (err) => {
        if (err.data) {
          alert(err.data);
        } else {
          alert("Server issue detected, please contact admin.");
        }
      })
    } else {
      this.props.fetchGroups(true);
    }

    let currentCategoryGroup = this.props.currentCategoryGroup;
    if (currentCategoryGroup && currentCategoryGroup.currentGroup) {
      if (currentCategoryGroup.currentGroup != -1) {
        this.props.fetchGroupCategories(currentCategoryGroup.currentGroup);
      }
      let selectedRows = currentCategoryGroup.selectedRows;
      this.setState({
        currentDep: currentCategoryGroup.currentDep,
        currentGroup: currentCategoryGroup.currentGroup,
        currentCategory: currentCategoryGroup.currentCategory,
        groupExpanded: (isGFD && true) ? false : true,
        depExpanded: true,
        // rows: currentCategoryGroup.currentRows,
        selectedRows,
        selectedRowsIdx: currentCategoryGroup.selectedRowsIdx,
      });
    }

    // if(currentCategoryGroup && currentCategoryGroup.filters) {
    //   this.setState({filters: currentCategoryGroup.filters})
    // }
    // this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
  }

  // Once products are ready, reset state.
  componentWillReceiveProps(nextProps) {
    if (nextProps.product && nextProps.product !== this.props.product) {
      let index = _.findIndex(this.state.rows, { Product_id: nextProps.product });
      this.state.rows.map(r => r.isSelected = false);
      if (index > -1) {
        this.state.rows[index].isSelected = true;
        this.setState({ selectedRows: [this.state.rows[index]] });
      } else {
        this.setState({ selectedRows: [] });
      }
    }

    if (!(isGFD && true) && nextProps.groups && nextProps.groups.length !== 0 && nextProps.groups !== this.props.groups) {
      let productGroup_id = nextProps.groups[0].ProductGroup_id;
      if (isHO || isJRC || isSH || isAP) {
        productGroup_id = -1;
      }
      if (this.state.currentCategory && this.state.currentCategory !== -1) {
        if(isVAK){
          this.props.fetchProductsByCategory(this.state.currentCategory, ()=>{}, ()=>{}, false, this.state.currentPage, this.state.limit);
        }else{
          this.props.fetchProductsByCategory(this.state.currentCategory);
        }
        // this.handleClickCategory(this.state.currentCategory);
      } else if (this.state.currentGroup) {
        if(isVAK){
           this.props.fetchProductsByGroup(this.state.currentGroup, null, null, null, this.state.currentPage, this.state.limit);
        }else{
          this.props.fetchProductsByGroup(this.state.currentGroup);
        }
      } else {
        if(isVAK){
          this.props.fetchProductsByGroup(productGroup_id, null, null, null, this.state.currentPage, this.state.limit);
        }else{
          this.props.fetchProductsByGroup(productGroup_id);
        }

        this.setState({ currentGroup: productGroup_id });
      }
    }

    if ((isGFD && true) && nextProps.deps && nextProps.deps.length !== 0 && nextProps.deps !== this.props.deps) {
      let productDepartment_id = nextProps.deps[0].ProductDepartment_id;
      if (isHO || isJRC) {
        productDepartment_id = -1;
      }
      if (this.state.currentGroup && this.state.currentGroup !== -1) {
        this.props.fetchProductsByGroup(this.state.currentGroup);
        // this.handleClickCategory(this.state.currentCategory);
      } else if (this.state.currentDep) {
        this.props.fetchProductsByGroup(this.state.currentDep, null, true, this.state.selectedBuyer);
      } else {
        this.props.fetchProductsByGroup(productDepartment_id, null, true);
        this.setState({ currentDep: productDepartment_id });
      }
    }

    if (nextProps.products && nextProps.products !== this.props.products) {
      let products = nextProps.products;
      if (this.props.currentCategoryGroup) {
        if (this.state.selectedRows.length) {
          const selectedRows = this.state.selectedRows;
          const selectedRowProductNumber = selectedRows[0].row.ProductNum;
          let selectedRowIdx;
          let rows = nextProps.products.map((product, idx) => {
            if (product.ProductNum === selectedRowProductNumber) {
              selectedRowIdx = idx;
              return {
                ...product,
                IsStopSale: product.IsStopSale ? 'yes' : 'no',
                isSelected: true,
              }
            }
            return {
              ...product,
              IsStopSale: product.IsStopSale ? 'yes' : 'no',
            }
          });
          this.setState({ rows, selectedRows });
          this.props.setGroupCategory(null);
          setTimeout(() => {
            var top = 25 * selectedRowIdx;
            var gridCanvas = this.tableGrid.getDataGridDOMNode().querySelector('.react-grid-Canvas');
            gridCanvas.scrollTop = top;
          }, 100);
        } else {
          let rows = nextProps.products.map((product, idx) => {
            return {
              ...product,
              IsStopSale: product.IsStopSale ? 'yes' : 'no',
            }
          });
          this.setState({ rows, selectedRows: [] });
        }
      } else {
        let rows = nextProps.products.map(product => ({
          ...product,
          IsStopSale: product.IsStopSale ? 'yes' : 'no',
        }));
        this.setState({ rows, selectedRows: [] });
        this.props.setGroupCategory(null);
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    let productDepartment_id = this.state.currentDep;
    let productGroup_id = this.state.currentGroup;
    let productCategory_id = this.state.currentCategory;

    let groups = document.getElementsByName('group');
    let i = 0;
    for (; i < groups.length; i++) {
      if (groups[i].id != 'g' + productGroup_id) {
        groups[i].style.backgroundColor = null;
      } else {
        groups[i].style.backgroundColor = APP_COLORS['active-category-background-nav'];
      }
    }

    let categories = document.getElementsByName('category');
    i = 0;
    if (categories) {
      for (; i < categories.length; i++) {
        if (categories[i].id != 'c' + productCategory_id) {
          categories[i].style.backgroundColor = null;
        } else {
          categories[i].style.backgroundColor = APP_COLORS['active-category-background-nav'];
        }
      }
    }

    let deps = document.getElementsByName('dep');
    i = 0;
    if (deps) {
      for (; i < deps.length; i++) {
        if (deps[i].id != 'd' + productDepartment_id) {
          deps[i].style.backgroundColor = null;
        } else {
          deps[i].style.backgroundColor = APP_COLORS['active-category-background-nav'];
        }
      }
    }
  }

  componentWillUnmount() {
    if (this.state.clear) { this.props.setGroupCategory(null); }
    this.props.setOriginPage('products');
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize(e) {
    this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton });
  }

  onChangeLowerRange(e) {
    this.setState({ lowerRange: e.target.value });
  }
  onChangeUpperRange(e) {
    this.setState({ upperRange: e.target.value });
  }

  onChangeQty(e) {
    this.setState({ printQty: e.target.value });
  }

  handleCheckHasPrice() {
    let { printHasPrice } = this.state;
    printHasPrice = !printHasPrice;
    this.setState({ printHasPrice });
  }

  onSearchRange(e) {
    let { searchType, lowerRange, upperRange, currentCategory, currentGroup } = this.state;
    let filters = { searchType: searchType, lowerRange: lowerRange, upperRange: upperRange };
    if (currentCategory !== -1) {
      this.props.fetchProductsByCategorySunset(currentCategory, filters);
    } else if (currentGroup !== -1) {
      this.props.fetchProductsByGroup(currentGroup, filters);
    } else {
      this.props.fetchProductsByGroup(-1, filters);
    }
  }

  // Quick Entry Product Number
  onChangeQuickEntry(e) {
    this.setState({ quickEntryProductNum: e.target.value });
  }

  onKeyPressQuickEntry(e) {
    const handleSuccess = (response) => {
      if (checkPermission('change_product')) {
        this.context.router.push('/products/' + response.data[0].Product_id);
      } else {
        alert(I18n.t('msg_no_permission'));
      }
    };
    const handleFailure = (error) => {
      this.setState({ quickEntryShowError: true });
    };
    if (e.charCode === 13) {
      if(isGGI) {
        this.props.resetCurrentProduct();
      }
      this.props.fetchQuickAccess(this.state.quickEntryProductNum, handleSuccess, handleFailure);
    }
  }

  // Set product being selected to be currentProduct and navigate user to the edit page
  setCurrentProduct(e) {
    e.preventDefault();
    this.setState({ clear: false });
    const currentProduct = this.state.selectedRows[0].row || this.state.selectedRows[0];
    let currentRows = Data.Selectors.getRows(this.state);
    this.props.resetCurrentProduct();
    this.props.selectProduct(currentProduct);
    this.props.setGroupCategory({
      currentGroup: this.state.currentGroup,
      currentCategory: this.state.currentCategory,
      currentProduct_id: currentProduct.Product_id,
      filters: this.state.filters,
      currentRows,
      selectedRowsIdx: this.state.selectedRowsIdx,
      selectedRows: this.state.selectedRows,
    });
    this.context.router.push('/products/' + currentProduct.Product_id);
  }

  checkDetail(data) {
    this.setState({ clear: false });
    const currentProduct = arguments[0];
    let currentRows = Data.Selectors.getRows(this.state);
    this.props.resetCurrentProduct();
    this.props.selectProduct(currentProduct);
    this.props.setGroupCategory({
      currentGroup: this.state.currentGroup,
      currentCategory: this.state.currentCategory,
      currentProduct_id: currentProduct.Product_id,
      filters: this.state.filters,
      currentRows,
      selectedRowsIdx: this.state.selectedRowsIdx,
      selectedRows: [{ row: data }],
    });
    this.context.router.push('/products/' + currentProduct.Product_id);
  }

  clickNew = (e) => {
    this.props.setGroupCategory({
      currentGroup: this.state.currentGroup,
      currentCategory: this.state.currentCategory,
      filters: this.state.filters,
      selectedRows: [],
    });
    e.preventDefault();
    this.setState({ clear: false });
    this.props.resetCurrentProduct();
    // this.props.setGroupCategory(null);
    this.context.router.push('/products/new');
  }

  handleClickCategory(id) {
    this.setState({ currentCategory: id });
    this.setState({ lowerRange: '', upperRange: '' });
    if (isVAK) {
      this.setState({ currentPage: 0 })
      this.props.fetchProductsByCategory(id, ()=>{}, ()=>{}, false, 0, 30, this.state.searchFilters)
    } else if (isSH || isAP) {
      this.props.fetchProductsByCategory(id, ()=>{}, ()=>{}, false, null, null, null, this.state.isDiscontinued);
    } else {
      this.props.fetchProductsByCategory(id);
    }
  }

  renderCategories(group_id) {
    if (!this.props.groupCategories) return;
    let groupCategories = this.props.groupCategories;
    let description;
    if (localStorage.getItem('lang') === 'ch') {
      description = 'Description';
    } else if (localStorage.getItem('lang') === 'en') {
      description = 'Name';
    }
    if (this.state.currentGroup === group_id && this.state.groupExpanded) {
      return groupCategories.map((category, i) => {
        let CategoryNum = parseInt(i) + 1;
        if (CategoryNum < 10) CategoryNum = '0' + CategoryNum;
        if (isGFD) {
          CategoryNum = parseInt(category.CategoryNum);
        }
        return (
          <li className="clickListLi" style={{ color: APP_COLORS['sub-category-nav'], fontFamily: 'Arial' }} name="category" id={'c' + category.ProductCategory_id} onClick={this.handleClickCategory.bind(this, category.ProductCategory_id)}>
            <label style={{ fontWeight: 'bold' }}>{CategoryNum}</label>{" " + category[description]}
          </li>
        );
      })
    }
    return;
  }

  handleBuyerChange = ( target ) => {
    this.setState({
      selectedBuyer: target.value,
    });
    this.state.selectedBuyer = target.value;
    this.setState({ currentDep: -1, currentGroup: null, currentCategory: -1, rows: [] });
    this.props.fetchDeps(target.value);
    // setTimeout(() => {
    //   this.setState({ currentDep: -1, currentGroup: null, currentCategory: -1 });
    //   this.props.fetchProductsByGroup(-1, null, null, this.state.selectedBuyer);
    //   // this.handleClickDep(null, '-1');
    // }, 500);
  }

  handleIsDiscontinuedChange = ( target ) => {
    this.setState({ isDiscontinued: target.value });
    if (this.state.currentCategory && this.state.currentCategory !== -1) {
      this.props.fetchProductsByCategory(this.state.currentCategory, null, null, false, null, null, null, target.value);
    } else if (this.state.currentGroup) {
      this.props.fetchProductsByGroup(this.state.currentGroup, null, null, null, null, null, target.value);
    } else {
      this.props.fetchProductsByGroup(this.state.currentGroup, null, null, null, null, null, target.value);
    }
  }

  handleClickGroup(group, id) {
    this.setState({ lowerRange: '', upperRange: '' });
    if(isVAK){
      this.setState({ currentPage: 0 })
    }
    let groupExpanded = this.state.groupExpanded;
    // for(; i < groups.length; i++) {
    //   if(groups[i].id != id){
    //     groups[i].style.color = APP_COLORS["category-nav"];
    //   }
    //   else {
    //     groups[i].style.color = APP_COLORS["active-category-nav"];
    //   }
    // }

    if (group && this.state.currentGroup === group.ProductGroup_id) {
      this.setState({ groupExpanded: !groupExpanded });
      if (!groupExpanded) {
        this.setState({ currentCategory: -1 });
        this.props.fetchProductsByGroup(group.ProductGroup_id);
        this.props.fetchGroupCategories(group.ProductGroup_id);
      }
    } else if (group) {
      this.setState({ currentGroup: group.ProductGroup_id, groupExpanded: true, currentCategory: -1 });
      if (isVAK) {
        this.props.fetchProductsByGroup(group.ProductGroup_id, this.state.searchFilters);
      } else if (isSH || isAP) {
        this.props.fetchProductsByGroup(group.ProductGroup_id, null, null, null, null, null, this.state.isDiscontinued);
      } else {
        this.props.fetchProductsByGroup(group.ProductGroup_id);
      }
      this.props.fetchGroupCategories(group.ProductGroup_id);
    } else {
      this.setState({ currentGroup: -1, currentCategory: -1 });
      this.props.fetchProductsByGroup(-1);
    }
  }

  handleClickDep(dep, id) {
    this.setState({ lowerRange: '', upperRange: '' });
    let depExpanded = this.state.depExpanded;
    // for(; i < groups.length; i++) {
    //   if(groups[i].id != id){
    //     groups[i].style.color = APP_COLORS["category-nav"];
    //   }
    //   else {
    //     groups[i].style.color = APP_COLORS["active-category-nav"];
    //   }
    // }
    if (dep && this.state.currentDep === dep.ProductDepartment_id) {
      this.setState({ depExpanded: !depExpanded });
      if (!depExpanded) {
        this.setState({ currentGroup: null, currentCategory: -1 });
        this.props.fetchProductsByGroup(dep.ProductDepartment_id, null, true);
        this.props.fetchDepCategories(dep.ProductDepartment_id);
      }
    } else if (dep) {
      this.setState({ currentDep: dep.ProductDepartment_id, depExpanded: true, currentGroup: null, currentCategory: -1 });
      this.props.fetchProductsByGroup(dep.ProductDepartment_id, null, true);
      this.props.fetchDepCategories(dep.ProductDepartment_id);
    } else {
      this.setState({ currentDep: -1, currentGroup: null, currentCategory: -1 });
      this.props.fetchProductsByGroup(-1, null, null, this.state.selectedBuyer);
    }
  }

  renderDeps() {
    if (!this.props.deps) return;
    let deps = this.props.deps;
    return deps.map(dep => {
      let DepNum = parseInt(dep.DepartmentNum);
      // if (DepNum < 10) DepNum = '0' + DepNum;
      let description;
      if (localStorage.getItem('lang') === 'ch') {
        description = 'Description';
      } else if (localStorage.getItem('lang') === 'en') {
        description = 'Name';
      }
      return (
        <Panel className="panelStyle" >
          <div style={{ color: 'purple', marginLeft: '-5px', fontSize: '13px', fontFamily: 'Arial Black', cursor: 'pointer' }} name="dep" id={'d' + dep.ProductDepartment_id} onClick={this.handleClickDep.bind(this, dep, 'd' + dep.ProductDepartment_id)}>
            <label style={{ fontWeight: 'bold' }}>{DepNum}</label> {' '}<Translate value={dep[description]} />
          </div>
          {this.renderGroupsGfd(dep.ProductDepartment_id)}
          {/* {this.renderCategories(group.ProductGroup_id)} */}
        </Panel>
      );
    })
  }

  renderGroupsGfd(dep_id) {
    if (!this.props.groups) return;
    let groups = this.props.groups;
    let description;
    if (localStorage.getItem('lang') === 'ch') {
      description = 'Description';
    } else if (localStorage.getItem('lang') === 'en') {
      description = 'Name';
    }

    if (this.state.currentDep === dep_id && this.state.depExpanded && !this.props.groupCategoryIsLoading) {
      return groups.map(group => {
        let GroupNum = parseInt(group.GroupNum);
        if (GroupNum < 10) GroupNum = '0' + GroupNum;
        return (
          // <Panel className="panelStyle" >
          //   <div style={{ color: APP_COLORS['category-nav'], fontFamily: 'Arial Black', cursor: 'pointer' }} name="group" id={'g'+group.ProductGroup_id} onClick = {this.handleClickGroup.bind(this, group, 'g'+group.ProductGroup_id)}>
          //     <label style={{ fontWeight: 'bold' }}>{GroupNum}</label> {' '}<Translate value={group[description]} />
          //   </div>
          //   {this.renderCategories(group.ProductGroup_id)}
          // </Panel>
          <div>
            <li className="clickListLi2" style={{ color: APP_COLORS['category-nav'], fontFamily: 'Arial Black', cursor: 'pointer' }} name="group" id={'g' + group.ProductGroup_id} onClick={this.handleClickGroup.bind(this, group, 'g' + group.ProductGroup_id)}>
              <label style={{ fontWeight: 'bold' }}>{GroupNum}</label> {' '}<Translate value={group[description]} />
            </li>
            {this.renderCategories(group.ProductGroup_id)}
          </div>
        );
      })
    }
    return;
  }

  renderGroups() {
    if (!this.props.groups) return;
    let groups = this.props.groups;
    return groups.map((group, i) => {
      // let GroupNum = parseInt(group.GroupNum);
      // use index instead
      let GroupNum = parseInt(i) + 1;
      if (GroupNum < 10) GroupNum = '0' + GroupNum;

      let description;
      if (localStorage.getItem('lang') === 'ch') {
        description = 'Description';
      } else if (localStorage.getItem('lang') === 'en') {
        description = 'Name';
      }

      return (
        <Panel className="panelStyle" >
          <div style={{ color: APP_COLORS['category-nav'], fontFamily: 'Arial Black', cursor: 'pointer' }} name="group" id={'g' + group.ProductGroup_id} onClick={this.handleClickGroup.bind(this, group, 'g' + group.ProductGroup_id)}>
            <label style={{ fontWeight: 'bold' }}>{GroupNum}</label> {' '}<Translate value={group[description]} />
          </div>
          {this.renderCategories(group.ProductGroup_id)}
        </Panel>
      );
    })
  }

  onDrop(files) {
    this.props.attachDocument(files);
    this.setState({ files });
  }

  renderTable() {
    // if (this.props.isLoading && !this.props.error) {
    //   return <Spinner />
    // } else if (this.props.error) {
    //   return (
    //     <ContentWrapper>
    //       <div id="product-error-wrapper">
    //         <div className="alert alert-danger">{JSON.stringify(this.props.error)}</div>
    //       </div>
    //     </ContentWrapper>
    //   );
    // }

    // Parameters of the react-data-grid
    let tableHeight = (window.innerHeight < 930) ? 680 : 739;

    const getRows = () => Data.Selectors.getRows(this.state);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state, { sortColumn, sortDirection });
      // var state = { ...this.state, sortColumn, sortDirection };
      this.setState(state);
    };

    const handleFilterChange = debounce((filter) => {
      let newFilters = Object.assign({}, this.state.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      let searchFilters = Object.assign({}, this.state.searchFilters);
      if (filter.filterTerm) {
        searchFilters[filter.column.key] = filter;
      } else {
        delete searchFilters[filter.column.key];
      }
      this.setState({
        searchFilters,
      })
      if (isVAK) {
        if (this.state.currentGroup) {
          this.props.fetchProductsByGroup(this.state.currentGroup, searchFilters)
        } else {
          this.props.fetchProductsByGroup(productGroup_id, searchFilters)
        }
      } else {
        this.setState({
          filters: newFilters,
          rows: this.props.products.map(product => ({
            ...product,
            IsStopSale: product.IsStopSale ? 'yes' : 'no',
          })),
        });
      }
    },200);

    const onClearFilters = () => {
      // all filters removed
      this.setState({
        filters: {},
        rows: this.props.products.map(product => ({
          ...product,
          IsStopSale: product.IsStopSale ? 'yes' : 'no',
        })),
      });
    };
    const handleOnPageChange = (data) => {
      this.state.currentPage = data.selected;
      const route = this.context.router.routes[1].path;
      let filterParams = "";
      if (this.state.currentCategory && this.state.currentCategory !== -1) {
        if (isVAK) {
          this.props.fetchProductsByCategory(this.state.currentCategory, ()=>{}, ()=>{}, false, this.state.currentPage, this.state.limit, this.state.searchFilters);
        } else {
          this.props.fetchProductsByCategory(this.state.currentCategory, ()=>{}, ()=>{}, false, this.state.currentPage, this.state.limit);
        }
        // this.handleClickCategory(this.state.currentCategory);
      } else if (this.state.currentGroup) {
        if (isVAK) {
          this.props.fetchProductsByGroup(this.state.currentGroup, this.state.searchFilters, null, null, this.state.currentPage, this.state.limit );
        } else {
          this.props.fetchProductsByGroup(this.state.currentGroup, null, null, null, this.state.currentPage, this.state.limit );
        }
      } else {
        if (isVAK) {
          this.props.fetchProductsByGroup(productGroup_id, this.state.searchFilters, null, null, this.state.currentPage, this.state.limit);
        } else {
          this.props.fetchProductsByGroup(productGroup_id, null, null, null, this.state.currentPage, this.state.limit);
        }
        this.setState({ currentGroup: productGroup_id });
      }
    }

    let limitSelection = [
      {
        label: '25',
        value: 25,
        name: 'limit',
      },
      {
        label: '50',
        value: 50,
        name: 'limit',
      },
      {
        label: '100',
        value: 100,
        name: 'limit',
      },
      {
        label: <Translate value="all" />,
        value: 99999,
        name: 'limit',
      },
    ]
    if (isVAK) {
      limitSelection = [{
        label: '30',
        value: 30,
        name: 'limit',
      }]
    }

    const handleLimitChange = (el) => {
      this.state.currentPage = 0;
      this.state.limit = el.value;
      this.state.limitDisplay = el.label;
      const route = this.context.router.routes[1].path;
      let filterParams = "";
      if (this.state.currentCategory && this.state.currentCategory !== -1) {
        this.props.fetchProductsByCategory(this.state.currentCategory, ()=>{}, ()=>{}, false, this.state.currentPage, this.state.limit);
        // this.handleClickCategory(this.state.currentCategory);
      } else if (this.state.currentGroup) {
        this.props.fetchProductsByGroup(this.state.currentGroup, null, null, null, this.state.currentPage, this.state.limit );
      } else {
        this.props.fetchProductsByGroup(productGroup_id, null, null, null, this.state.currentPage, this.state.limit);
        this.setState({ currentGroup: productGroup_id });
      }
    }
    // Handle the row select function

    const onRowSelect = (rows) => {
      this.setState({ selectedRows: rows });
    };

    const onRowsSelected = (rows) => {
      if (isSV || isCRW || isGFD || isSC) {
        let newRows = getRows();
        let selectedRows = this.state.selectedRows;
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = true;
          selectedRows.push({ row: r.row });
        });
        this.setState({ rows: newRows, selectedRows, selectedRowsIdx: rows[0].rowIdx });
      } else {
        let newRows = [...this.state.rows];
        let selectedRows = this.state.selectedRows;

        newRows.map((r) => {
          r.isSelected = false;
        });

        selectedRows = [];
        rows.map((row) => {
          let index = _.findIndex(this.state.rows, { 'ProductNum': row.row.ProductNum })
          newRows[index].isSelected = true;
          selectedRows.push(row);
        });

        this.setState({ rows: newRows, selectedRows, selectedRowsIdx: rows[0].rowIdx });
      }
    };

    const onRowsDeselected = (rows) => {
      if (isSV || isCRW || isGFD || isSC) {
        let newRows = [...this.state.rows];
        let selectedRows = this.state.selectedRows;
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = false;
          const rowIndex = selectedRows.indexOf(r.row);
          selectedRows.splice(rowIndex, 1);
        });
        this.setState({ rows: newRows, selectedRows });
      } else {
        let newRows = [...this.state.rows];
        rows.map((row) => {
          let index = _.findIndex(this.state.rows, { 'ProductNum': row.row.ProductNum })
          newRows[index].isSelected = false;
        });
        let selectedRows = [];
        newRows.map((r) => {
          if (r.isSelected) { selectedRows.push(r); }
        })
        this.setState({ rows: newRows, selectedRows });
      }
    };

    // Custom Formatter component
    const NameFormatter = React.createClass({
      render() {
        if (this.props.value) return <span>{this.props.value.Name}</span>;
        return <span className="label label-danger">-</span>;
      },
    });

    // Discontinued Product Background Color Formatter
    const DiscontinuedProductCellBackGroundFormatter = (props) => {
      const rowBackground = props.dependentValues.IsDiscontinued
        ? BACKGROUND_COLOR.lightGray
        : '';
      if (isSV) {
        return (
          <div style={{ backgroundColor: rowBackground }}
            onDoubleClick={() => this.checkDetail(props.dependentValues)}>
            <span>{props.value}</span>
          </div>
        );
      } else {
        return (
          <div style={{ backgroundColor: rowBackground }}>
            <span>{props.value}</span>
          </div>
        );
      }
    };

    // formatter for IsStopSale
    const IsStopSaleFormatter = React.createClass({
      render() {
        if (this.props.value === 'no') return <span className="label label-success"><Translate value="no" /></span>;
        return <span className="label label-danger"><Translate value="yes" /></span>;
      },
    });

    // Column difinition
    let columns = [
      ...!(isSV || isOLG) ? [{
        key: 'ProductNum',
        name: <Translate value="prod_num" />,
        resizable: true,
        sortable: true,
        width: 70,
        filterable: true,
        filterRenderer: FilterByStart,
        formatter: DiscontinuedProductCellBackGroundFormatter,
        getRowMetaData: row => row,
      }] : [],
      {
        key: 'GeneralNum',
        name: <Translate value='ref_style' />,
        resizable: true,
        sortable: true,
        width: 140,
        filterable: true,
        filterRenderer: FilterByStart,
        formatter: DiscontinuedProductCellBackGroundFormatter,
        getRowMetaData: row => row,
      },
      {
        key: 'RefNum',
        name: <Translate value="style" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        filterRenderer: FilterMultiKeyword,
        formatter: DiscontinuedProductCellBackGroundFormatter,
        getRowMetaData: row => row,
      },
      {
        key: 'Name',
        name: <Translate value={(isSH || isAP) ? 'product_name' : 'item_name'} />,
        resizable: true,
        sortable: true,
        width: 200,
        filterable: true,
        filterRenderer: FilterMultiKeyword,
        formatter: DiscontinuedProductCellBackGroundFormatter,
        getRowMetaData: row => row,
      },
      {
        key: 'Size',
        name: <Translate value="size" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: 'ProductGroup_id__Name',
        name: <Translate value="group" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: 'ProductCategory1_id__Name',
        name: <Translate value="category_1" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: 'ProductCategory2_id__Name',
        name: <Translate value="category_2" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: 'IsStopSale',
        name: <Translate value="is_stop_sale" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: IsStopSaleFormatter,
      },
    ];

    if (isABCFF) {
      columns = [
        {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          filterRenderer: FilterByStart,
          formatter: DiscontinuedProductCellBackGroundFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'GeneralNum',
          name: <Translate value={(isMyuMyu || isAFG) ? 'index_no' : 'general_no'} />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          filterRenderer: FilterByStart,
          formatter: DiscontinuedProductCellBackGroundFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'RefNum',
          name: (isTN || isWIZ) ? <Translate value="sku" /> : <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          filterRenderer: FilterMultiKeyword,
          formatter: DiscontinuedProductCellBackGroundFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'Name',
          name: <Translate value="item_name" />,
          resizable: true,
          sortable: true,
          width: 200,
          filterable: true,
          filterRenderer: FilterMultiKeyword,
          formatter: DiscontinuedProductCellBackGroundFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'Description',
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
          formatter: DiscontinuedProductCellBackGroundFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'CustomerName',
          name: <Translate value="customer" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        },
        {
          key: 'VendorStyleNum',
          name: <Translate value="vendor_style" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        },
        {
          key: 'TJXStyleNum',
          name: <Translate value="tjx_style" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        },
        {
          key: 'UPC',
          name: <Translate value="upc" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        },
        {
          key: 'Color',
          name: <Translate value="color" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        },
        {
          key: 'Size',
          name: <Translate value="size/ratio" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        },
        {
          key: 'RefPrice',
          name: <Translate value="unit_price" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'MeasureUnit',
          name: <Translate value="mm_unit" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
        },
        {
          key: 'ProductGroup_id__Name',
          name: <Translate value="prod_group" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'ProductCategory1_id__Name',
          name: <Translate value="category_1" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'ProductCategory2_id__Name',
          name: <Translate value="category_2" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'IsStopSale',
          name: <Translate value="is_stop_sale" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          formatter: IsStopSaleFormatter,
        },
        {
          key: 'IsMobile',
          name: <Translate value="is_mobile_sale" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          formatter: IsStopSaleFormatter,
        },
      ];
    }

    if (isAFG || isMyuMyu || isWecom) {
      const indexGeneralNum = _.findIndex(columns, { key: 'GeneralNum' });
      const generalColumn = {
        key: 'GeneralNumDisplay',
        name: <Translate value={(isMyuMyu || isAFG || isWecom) ? 'index_no' : 'general_no'} />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        // filterRenderer: FilterByStart,
        formatter: DiscontinuedProductCellBackGroundFormatter,
        getRowMetaData: row => row,
      }
      columns.splice(indexGeneralNum, 1, generalColumn);
      if (this.state.rows.length > 0) {
        this.state.rows.map((row) => {
          if (row.GeneralNum) {
            row.GeneralNumDisplay = Number(row.GeneralNum);
          } else {
            row.GeneralNumDisplay = null;
          }
        });
      }
    }

    if (isSKH) {
      const ProductGroup_id__NameIdx = _.findIndex(columns, { key: 'ProductGroup_id__Name' });
      const inventoryCol = {
        key: 'Inventory',
        name: <Translate value={'inventory'} />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
      }
      columns.splice(ProductGroup_id__NameIdx, 0, inventoryCol);
    }
    if (isSW) {
      const GNIndex = _.findIndex(columns, { key: 'GeneralNum' });
      const barcode = {
        key: 'Barcode',
        name: <Translate value={'barcode'} />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
      };
      columns.splice(GNIndex, 1, barcode);
    }
    const totalPages = this.props.productTotalPages
    return (
      <div>
        <Row>
          <Col xs={12}>
            <div style={{ maxWidth: '99%', marginTop: isGFD ? "35px" : "0px" }} id="Products-dataGrid1">
              <ReactDataGrid
                ref="testingstuff"
                rowRenderer={
                  <RowRenderer
                    onDoubleClick={(data) => {
                      if (!isSV) {
                        if (checkPermission('change_product') && !(isOLG || isVAK) ||
                        (isOLG || isVAK) && checkPermission('view_product')) {
                          this.checkDetail(data);
                        } else {
                          alert(I18n.t('msg_no_permission'));
                        }
                      }
                    }
                    }
                  />
                }
                rowKey="Product_id"
                ref={g => this.tableGrid = g}
                onGridSort={handleGridSort}
                enableCellSelect={true}
                toolbar={<Toolbar enableFilter={true} />}
                onAddFilter={handleFilterChange}
                onClearFilters={onClearFilters}
                columns={columns}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                rowHeight={25}
                headerRowHeight={45}
                minHeight={653}
                enableRowSelect={(isSV || isCRW || isGFD || isSC) ? "multi" : "single"}
                onRowUpdated={this.handleRowUpdated}
                onRowSelect={onRowSelect}
                rowSelection={{
                  enableShiftSelect: (isSV || isCRW || isGFD || isSC) ? true : false,
                  showCheckbox: true,
                  onRowsSelected,
                  onRowsDeselected,
                  selectBy: {
                    isSelectedKey: 'isSelected',
                  },
                }}
              />
            </div>
          </Col>
        </Row>

        {isVAK &&
          <Row>
            <Col xs={6} style={{display: 'flex'}}>
              <div style={{ width: '600px' }} id="react-pagination">
                <ReactPaginate
                  previousLabel={<Translate value="prev_page" />}
                  nextLabel={<Translate value="next_page" />}
                  containerClassName={'pagination'}
                  activeClassName={'active'}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  pageCount={totalPages}
                  onPageChange={handleOnPageChange}
                  forcePage={this.state.currentPage}
                />
              </div>
              <div  style={{ width: '100px', marginTop: '6px', marginLeft: '15px'}}>
                <Dropdown>
                  <Dropdown.Toggle style={{ height: '28px', width: '60px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                    {this.state.limitDisplay}
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="super-colors">
                    {limitSelection.map(el => {
                      return (
                        <MenuItem onClick={() => handleLimitChange(el)}>{el.label}</MenuItem>
                      )
                    })}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Col>
          </Row>
        }
      </div>
    );
  }

  renderTNProductButton() {
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        type="button"
        onClick={() => { this.refs.importProduct.click(); }}
      >
        <em className="fa fa-upload" /><Translate value="product" />
      </Button>
    )
  }

  renderExcel() {
    const {
      currentCategory,
      currentGroup,
    } = this.state;

    let exportUrl = ``;
    let text = "Print Label (All)";

    if (currentCategory !== -1) {
      exportUrl = `${ROOT_URL}v1/product/print_label/?ProductCategory1_id=${currentCategory}&Bearer=${localStorage.getItem("token")}`;
      text = "Print Label (Category)"
    } else if (currentGroup !== -1) {
      exportUrl = `${ROOT_URL}v1/product/print_label/?ProductGroup_id=${currentGroup}&Bearer=${localStorage.getItem("token")}`;
      text = "Print Label (Group)"
    } else {
      exportUrl = `${ROOT_URL}v1/product/print_label/?Bearer=${localStorage.getItem("token")}`;
      text = "Print Label (All)"
    }

    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        // onClick={() => { console.log("id",currentGroup,currentCategory) }}
        disabled={false}
      >
        <em className="fa fa-download" />
        &nbsp;{text}
      </Button>
    );
  }

  renderTNBarcodeButton() {
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        type="button"
        onClick={() => { this.refs.importBarcode.click(); }}
      >
        <em className="fa fa-upload" /><Translate value="barcode" />
      </Button>
    )
  }

  renderTNTemplatButton() {
    const templateUrl = `${ROOT_URL}v2/product/import-template?Bearer=${localStorage.getItem("token")}`;
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        type="button"
        href={templateUrl}
      >
        <em className="fa fa-download" /><Translate value="product_template" />
      </Button>
    )
  }

  renderTNBarcodeTemplatButton() {
    const templateUrl = `https://scmteambucket.s3.us-west-1.amazonaws.com/TN_Barcode_Templete.xlsx`;
    // const templateUrl = `${ROOT_URL}v2/product/barcode-template?Bearer=${localStorage.getItem("token")}`;
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        type="button"
        href={templateUrl}
      >
        <em className="fa fa-download" /><Translate value="barcode_template" />
      </Button>
    )
  }

  renderImport () {
    if(!isVAK) return null;
    return (
      <div style={{ display:'inline-flex', flexDirection:'row', width: '86px', marginLeft: '10px' }}>
        <input type='file' id='uploadInv' style={{ opacity: 0, width: '86px' }} onChange={(event) => {
          var file = event.target.files[0];
          if (file) {
            this.setState({isImporting: true}, ()=>{
              this.props.importProducts(file, (response) => {
                if (response) {
                  fileDownload(response, 'import_result.xlsx');
                }
                this.setState({isImporting:false});
              })
            })
          }
        }} />
        <Button
        className="btn-primary-absolute"
        type="button"
        disabled={this.state.isImporting}
        onClick={() => {
          document.getElementById('uploadInv').click();
        }}
        >
          <em className="fa fa-upload" /><Translate value="import" />
        </Button>
      </div>)
  }

  renderVAKExcel () {
    if(!isVAK) return null;
    return <Button
    bsStyle="success"
    type="button"
    href={'https://scmteambucket.s3.amazonaws.com/media/vakker/3f51e1e6-5e02-11ef-8760-e202d45f2d2c.xls'}
  >
    <em className="fa fa-download" /><Translate value="excel" />
  </Button>
  }

  renderGFDUploadProduct = () => {
    return <SpinnerButton
      bsStyle="success"
      translation={<Translate value="upload" />}
      loading={this.state.productImportLoading}
      onClick={() => {this.refs.importProduct.click();}}
      icon="fa-upload"
    />
  }

  renderGFDUploadVPN = () => {
    return <SpinnerButton
      bsStyle="success"
      translation={<Translate value="upload_replace_vpn" />}
      loading={this.state.productImportLoading}
      onClick={() => {this.refs.importVpn.click();}}
      icon="fa-upload"
    />
  }

  renderCRWBarcode = () => {
      const {
        currentCategory,
        currentGroup,
        selectedRows,
      } = this.state;

      let prodIds = [];
      if ( selectedRows && selectedRows.length > 0) {
        selectedRows.map((r) => {
          prodIds.push(r.row.Product_id);
        });
      }

      // let href = `${ROOT_URL}v1/product/export_product?warehouse=${this.props.selectedWarehouse.value}&group=${currentGroup}&category=${currentCategory}&Bearer=${localStorage.getItem('token')}`;
      let href = `${ROOT_URL}v1/warehouse/printbarcode_multi/${prodIds}?Bearer=${localStorage.getItem('token')}`;
      // http://localhost:8001/v1/warehouse/printbarcode_multi/1,2,3,4,5?Bearer=aYgSIVpVQis4OoeOfoqs93JOHb92rd
      return <SpinnerButton
        bsStyle="success"
        icon="fa-download"
        translation={<Translate value="export_barcode" />}
        disabled={selectedRows.length < 1}
        href={href}
        target="_blank"
      />
  }

  renderGFDDownloadProduct = () => {
    // v1/product/export_product?warehouse=&group=&category&department
    if (isGFD) {
      const {
        currentCategory,
        currentGroup,
        currentDep,
        selectedRows,
      } = this.state;

      const handleClick = () => {
        if (this.state.isGFDExportLoading) {
          return;
        }
        this.setState({
          isGFDExportLoading: true,
        }, () => {
          const data = {
            warehouse: this.props.selectedWarehouse.value,
            category: currentCategory,
          }
          if (currentGroup) {
            data.group = currentGroup;
          }
          if (currentDep !== -1) {
            data.department = currentDep;
          }
          if (selectedRows.length > 0) {
            data.product_ids = selectedRows.map(r => r.row.Product_id);
          }
          axios.post(`${ROOT_URL}v1/product/export_product`, data, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
            responseType: 'blob',
          }).then(response => {
            const filename = response.headers['content-disposition'].split('filename=')[1];
            fileDownload(response.data, filename || '')
            this.setState({
              isGFDExportLoading: false,
            });
          }, err => {
            alert(err.statusText)
            this.setState({
              isGFDExportLoading: false,
            });
          })
        });
      }
      return <SpinnerButton
        bsStyle="success"
        icon="fa-download"
        onClick={handleClick}
        translation={<Translate value="existing_product_export" />}
        loading={this.state.isGFDExportLoading}
      />
    }
  }

  renderDownloadItems = () => {
    if (isGFD) {
      const product_ids = this.state.selectedRows.map(r => r.row.Product_id);
      const {
        currentCategory,
        currentGroup,
        currentDep,
      } = this.state;
      return <Button
      bsStyle="success"
      className="print-btn"
      type="button"
      onClick={() => {
        const params = {
          product_ids: product_ids.join(','),
          warehouse: this.props.selectedWarehouse.value,
        };
        if (currentCategory !== -1) {
          params.category = currentCategory
        }
        if (currentDep !== -1) {
          params.department = currentDep
        }
        axios.get(`${ROOT_URL}v1/product/export_product`, {
          params,
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          responseType: 'blob',
        }).then(res => {
          var a = document.createElement('a');
          a.target = '_blank'
          a.href =URL.createObjectURL(res.data);
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        })}}
    >
      <em className="fa fa-download" /><Translate value="export_products" />
    </Button>
    }
  }

  renderGFDDownloadTemplate = () => {
    if (isGFD) {
      return <Button
        bsStyle="success"
        type="button"
        // onClick={() => {
        //   axios.get(`${ROOT_URL}v1/product/product-template?Bearer=${localStorage.getItem('token')}`).then(res => {
        //     console.log('res: ', res);
        //     window.location.href = res.data;
        //   })
        // }}
        href={`${ROOT_URL}v1/product/export_product?template=True&Bearer=${localStorage.getItem('token')}`}
        // href={`${ROOT_URL}v1/product/product-template?Bearer=${localStorage.getItem('token')}`}
        // href={`https://scmteambucket.s3.us-west-1.amazonaws.com/product_template.xlsx`}
      >
        <em className="fa fa-download" /><Translate value="new_product_template" />
      </Button>
    }
  }

  renderGFDVPNTemplate = () => {
      return <Button
        bsStyle="success"
        type="button"
        onClick={() => {
          axios.get(`${ROOT_URL}v1/product/vpn-template?Bearer=${localStorage.getItem('token')}`).then(res => {
            window.location.href = res.data;
          })
        }}
        // href={`${ROOT_URL}v1/product/product-template?Bearer=${localStorage.getItem('token')}`}
        // href={`https://scmteambucket.s3.us-west-1.amazonaws.com/product_template.xlsx`}
      >
        <em className="fa fa-download" /><Translate value="new_vpn_template" />
      </Button>
  }

  render() {
    let selectedProd = null;
    if (this.state.selectedRows && this.state.selectedRows.length === 1) {
      selectedProd = this.state.selectedRows[0].row.ProductNum;
    }
    const url10 = `${ROOT_URL}v1/warehouse/printbarcode/${selectedProd}?Bearer=${localStorage.getItem('token')}`;
    const url30 = `${ROOT_URL}v1/warehouse/printbarcode2/${selectedProd}?Bearer=${localStorage.getItem('token')}`;

    let selectedProdNew = [];
    let selectedProdString = null;
    if (this.state.selectedRows && this.state.selectedRows.length > 0) {
      this.state.selectedRows.map(r => {
        selectedProdNew.push(r.row.Product_id);
      });
      selectedProdString = selectedProdNew.join(',');
    }
    const url10new = `${ROOT_URL}v1/warehouse/printbarcodeid/${selectedProdString}?quantity=${this.state.printQty}&hasPrice=${this.state.printHasPrice}&Bearer=${localStorage.getItem('token')}`;
    const url30new = `${ROOT_URL}v1/warehouse/printbarcode2id/${selectedProdString}?quantity=${this.state.printQty}&hasPrice=${this.state.printHasPrice}&Bearer=${localStorage.getItem('token')}`;

    const searchOptions = [
      { label: 'General Num', value: 'GeneralNum' },
      { label: 'Class Num', value: 'ClassNo' },
    ];
    const discontinueOptions = [
      { label: <Translate value="all" />, value: 'all' },
      { label: <Translate value="yes" />, value: 1 },
      { label: <Translate value="no" />, value: 0 },
    ]

    let shEexportUrl = `${ROOT_URL}v2/product/export?Bearer=${localStorage.getItem("token")}`;
    let excelUrl = `${ROOT_URL}v2/inventory?format=csv&belong_warehouse=false&warehouse=1&order=product__RefNum&company=1&no_show_product_cost=false&Bearer=${localStorage.getItem('token')}`;
    let { searchType, lowerRange, upperRange, currentCategory, currentGroup, isDiscontinued } = this.state;

    if (searchType && lowerRange && upperRange) {
      if (currentCategory !== -1) {
        excelUrl = `${ROOT_URL}v2/inventory?format=csv&category=${currentCategory}&searchType=${searchType}&lowerRange=${lowerRange}&upperRange=${upperRange}&belong_warehouse=false&warehouse=1&order=product__RefNum&company=1&no_show_product_cost=false&Bearer=${localStorage.getItem('token')}`;
        shEexportUrl += `&ProductCategory1_id=${currentCategory}`;
      } else if (currentGroup !== -1) {
        excelUrl = `${ROOT_URL}v2/inventory?format=csv&group=${currentGroup}&searchType=${searchType}&lowerRange=${lowerRange}&upperRange=${upperRange}&belong_warehouse=false&warehouse=1&order=product__RefNum&company=1&no_show_product_cost=false&Bearer=${localStorage.getItem('token')}`;
        shEexportUrl += `&ProductGroup_id=${currentGroup}`;
      } else {
        excelUrl = `${ROOT_URL}v2/inventory?format=csv&searchType=${searchType}&lowerRange=${lowerRange}&upperRange=${upperRange}&belong_warehouse=false&warehouse=1&order=product__RefNum&company=1&no_show_product_cost=false&Bearer=${localStorage.getItem('token')}`;
      }
    } else {
      if (currentCategory !== -1) {
        excelUrl = `${ROOT_URL}v2/inventory?format=csv&category=${currentCategory}&belong_warehouse=false&warehouse=1&order=product__RefNum&company=1&no_show_product_cost=false&Bearer=${localStorage.getItem('token')}`;
        shEexportUrl += `&ProductCategory1_id=${currentCategory}`;
      } else if (currentGroup !== -1) {
        excelUrl = `${ROOT_URL}v2/inventory?format=csv&group=${currentGroup}&belong_warehouse=false&warehouse=1&order=product__RefNum&company=1&no_show_product_cost=false&Bearer=${localStorage.getItem('token')}`;
        shEexportUrl += `&ProductGroup_id=${currentGroup}`;
      } else {
        excelUrl = `${ROOT_URL}v2/inventory?format=csv&belong_warehouse=false&warehouse=1&order=product__RefNum&company=1&no_show_product_cost=false&Bearer=${localStorage.getItem('token')}`;
      }
    }

    if ((isSH || isAP) && (isDiscontinued === 0 || isDiscontinued == 1)) {
      shEexportUrl += `&IsDiscontinued=${isDiscontinued}`;
    }

    return (
      //---------------
      // Begin HTML
      //---------------
      <ContentWrapper>

        {/* Nav Trail */}
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="general_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="style_list" />
          </Breadcrumb.Item>
        </Breadcrumb> {/* End Nav Trail */}

        <Grid id="products-inventory-page">
          <Row>
            {/* Inventory Nav */}
            <Col xs={2}>
              <Panel id="category-nav" className="panelStyle" style={{ overflowY: 'scroll', width: '100%' }}>

                {(isGFD) &&
                  <Panel className="panelStyle" >
                    <div className="buyerGFD" style={{ marginTop: '0px', marginBottom: "0px" }}>
                      <GenericSelection
                        options={this.state.buyerOptions}
                        value={this.state.selectedBuyer}
                        setSelected={(e) => { this.handleBuyerChange(e) }}
                        disabled={this.props.gfdLoading}
                      />
                    </div>
                  </Panel>
                }

                {!(isGFD && true) &&
                  <Panel className="panelStyle" >
                    <div style={{ color: APP_COLORS['category-nav'], fontWeight: 'bold', cursor: 'pointer' }} name="group" id="g-1" onClick={this.handleClickGroup.bind(this, null, '-1')}>
                      <Translate value="all" />
                    </div>
                  </Panel>
                }
                {
                // (isGFD && (!this.state.selectedBuyer || this.state.selectedBuyer === "All")) &&
                isGFD &&
                  <Panel className="panelStyle" >
                    <div style={{ color: APP_COLORS['category-nav'], fontWeight: 'bold', cursor: 'pointer' }} name="dep" id="d-1" onClick={this.handleClickDep.bind(this, null, '-1')}>
                      <Translate value="all" />
                    </div>
                  </Panel>
                }
                {!(isGFD && true) && this.renderGroups()}
                {(isGFD && true) && this.renderDeps()}
              </Panel>
            </Col>
            {/* End Inventory Nav */}

            {/* Main Workspace */}
            <Col xs={10}>
              <Panel className="position-relative mb0" id="products">
                <ButtonToolbar className={isSV ? "" : isVAK ? "table-buttons display-flex" : "table-buttons"}>
                  <Button
                    bsStyle="primary"
                    type="button"
                    onClick={(event) => { this.clickNew(event); }}
                    disabled={!checkPermission('add_product')}
                  >
                    <em className="fa fa-plus" /><Translate value="create_product" />
                  </Button>
                  <Button
                    bsStyle="warning"
                    type="button"
                    onClick={(event) => { this.setCurrentProduct(event); }}
                    disabled={!this.state.selectedRows || this.state.selectedRows.length !== 1 || !checkPermission('change_product')}
                  >
                    <em className="fa fa-pencil" /><Translate value="edit_product" />
                  </Button>
                  {(isCRW || isSC) && this.renderCRWBarcode()}
                  {this.renderImport()}
                  {this.renderVAKExcel()}
                  { isGFD && this.renderGFDUploadProduct()}
                  {this.renderGFDDownloadProduct()}
                  {this.renderGFDDownloadTemplate()}
                  {this.renderDownloadItems()}
                  {(isSH || isAP) &&
                    <Button
                      bsStyle="success"
                      className="print-btn"
                      type="button"
                      disabled={ this.state.productImportLoading}
                      onClick={() => { this.refs.importProduct.click(); }}
                    >
                      <em className="fa fa-upload" /><Translate value="import" />
                    </Button>
                  }
                  {(isSH || isAP) &&
                    <Button
                      bsStyle="success"
                      className="print-btn"
                      type="button"
                      href={shEexportUrl}
                    >
                      <em className="fa fa-download" /><Translate value="export" />
                    </Button>
                  }
                  {/* {
                  isSV &&
                  <Button
                  type="button"
                  bsStyle="primary"
                  className="textAlignStyle"
                  href={url10}
                  disabled={!this.state.selectedRows || this.state.selectedRows.length !== 1}
                >
                  <em className="fa fa-print" /><Translate value="label_10" />
                </Button>
                } */}
                  {/* {
                isSV &&
                <Button
                  type="button"
                  bsStyle="primary"
                  className="textAlignStyle"
                  href={url30}
                  disabled={!this.state.selectedRows || this.state.selectedRows.length !== 1}
                >
                  <em className="fa fa-print" /><Translate value="label_30" />
                </Button>
              } */}
               <input
                    type="file"
                    style={{ display: "none" }}
                    onClick={(e) => {
                      e.target.value = null;
                    }}
                    onChange={(e) => {
                      let URL = `${ROOT_URL}v1/product/upload-vpn`;
                      const formData = new FormData();
                      formData.append("vpn_file", e.target.files[0]);
                      if (e.target.files[0]) {
                        this.setState({productImportLoading: true});
                        axios
                          .post(
                            URL,
                            formData,
                            {
                              headers: {
                                Authorization: `Bearer ${localStorage.getItem(
                                  "token"
                                )}`,
                              },
                            },
                          )
                          .then(
                            (res) => {
                              alert("VPN uploaded successfully");
                              this.setState({
                                productImportLoading: false,
                              })
                              // this.fetchSalesOrdersByDetails(
                              //   this.state.days
                              // );
                            },
                            (err) => {
                              this.setState({
                                productImportLoading: false,
                              })
                              if (err.data) {
                                alert(err.data);
                              } else {
                                alert("Server issue detected, please contact admin.");
                              }
                            }
                          );
                      }
                    }}
                    ref="importVpn"
                  />
                  <input
                    type='file'
                    ref='importProduct'
                    onClick={(e) => {
                      e.target.value = null;
                    }}
                    onChange={(e) => {
                      this.setState({ productImportLoading: true });
                      const file = e.target.files[0];
                      const formData = new FormData();
                      const success = (response) => {
                        this.setState({
                          productImportLoading: false,
                        }, () => {
                          this.props.resetGroupAndCategory();
                          if (isGFD) {
                            if (response) {
                              fileDownload(response, 'import_failure.xlsx');
                              alert("Product Upload has Failure: Pls open the downloaded error report to make changes and upload again. ");
                            } else {
                              alert("Product Upload Successful");
                            }
                            this.props.fetchDeps();
                          }
                        })
                      };
                      const failed = () => {
                        this.setState({
                          productImportLoading: false,
                        })
                      };
                      if (isSH || isAP) {
                        formData.append('FILE', file);
                        productUpload2(formData, success, failed);
                      } else if(isGFD) {
                        formData.append('product_file', file);
                        productUploadGFD(formData, success, failed);
                      } else {
                        formData.append('file', file);
                        productUpload(formData, success);
                      }
                    }}
                    style={{ display: 'none' }}
                  />
                  <input
                    type="file"
                    style={{ display: "none" }}
                    onClick={(e) => {
                      e.target.value = null;
                    }}
                    onChange={(e) => {
                      let URL = `${ROOT_URL}v2/product/import-barcode`;
                      const formData = new FormData();
                      formData.append("file", e.target.files[0]);
                      if (e.target.files[0]) {
                        axios
                          .post(
                            URL,
                            formData,
                            {
                              headers: {
                                Authorization: `Bearer ${localStorage.getItem(
                                  "token"
                                )}`,
                              },
                            },
                          )
                          .then(
                            (res) => {
                              alert("barcodes uploaded successfully");
                              // this.fetchSalesOrdersByDetails(
                              //   this.state.days
                              // );
                            },
                            (err) => {
                              if (err.data) {
                                alert(err.data);
                              } else {
                                alert("Server issue detected, please contact admin.");
                              }
                            }
                          );
                      }
                    }}
                    ref="importBarcode"
                  />

                  {false && this.renderExcel()}
                  {isTN && this.renderTNProductButton()}
                  {isTN && this.renderTNTemplatButton()}
                  {isTN && this.renderTNBarcodeButton()}
                  {isTN && this.renderTNBarcodeTemplatButton()}
                  <input
                    style={{ width: '150px', marginLeft: '5px', borderRadius: '5px', padding: '2px', border: '1px solid black' }}
                    type="text"
                    onChange={e => { this.onChangeQuickEntry(e); }}
                    onKeyPress={e => { this.onKeyPressQuickEntry(e); }}
                    value={this.state.quickEntryProductNum}
                    placeholder={I18n.t('product_num_ref_num')}
                  />
                  {(isSH || isAP) &&
                    <div className='sh-prod'>
                      <label className="control-label">Discontinued:</label>
                        <GenericSelection
                          options={discontinueOptions}
                          value={this.state.isDiscontinued}
                          setSelected={(e) => { this.handleIsDiscontinuedChange(e) }}
                        />
                    </div>
                  }
                  {
                    this.state.quickEntryShowError &&
                    <span style={{ marginLeft: '3px', color: 'red' }}>
                      <Translate value="product_not_found" />
                    </span>
                  }
                  {/*
                    <Dropzone onDrop={this.onDrop.bind(this)} className="upload-button">
                      <Button bsStyle="primary" >
                        <em className="fa fa-file-text" />
                        <Translate value="upload_import" />
                      </Button>
                    </Dropzone>
                  */}
                </ButtonToolbar>
                {isGFD &&
                  <ButtonToolbar className="table-buttons" style={{ marginTop: '33px' }}>
                  {this.renderGFDUploadVPN()}
                  {this.renderGFDVPNTemplate()}
                  </ButtonToolbar>
                }
                {
                  isSV &&
                  <ButtonToolbar className="table-buttons" style={{ marginTop: '33px' }}>
                    <div style={{ float: 'left', marginLeft: '5px' }}>
                      <div className='sunset-prod' style={{}}>
                        <label className="control-label">Filter Type:</label>
                        <GenericSelection
                          options={searchOptions}
                          value={this.state.searchType}
                          setSelected={(e) => { this.setState({ searchType: e.value }); }}
                        />
                      </div>
                      <span style={{ fontSize: '14px' }}>Range:</span>
                      <input
                        style={{ width: '70px', marginLeft: '5px', borderRadius: '5px', padding: '2px', border: '1px solid black' }}
                        type="text"
                        onChange={e => { this.onChangeLowerRange(e); }}
                        // onKeyPress={e => { this.onKeyPressQuickEntry(e); }}
                        value={this.state.lowerRange}
                      />
                      <span style={{ fontSize: '15px' }}> -</span>
                      <input
                        style={{ width: '70px', marginLeft: '5px', borderRadius: '5px', padding: '2px', border: '1px solid black' }}
                        type="text"
                        onChange={e => { this.onChangeUpperRange(e); }}
                        // onKeyPress={e => { this.onKeyPressQuickEntry(e); }}
                        value={this.state.upperRange}
                      />
                    </div>
                    <Button
                      className="search-button"
                      bsStyle="primary"
                      disabled={!this.state.searchType || !this.state.lowerRange || !this.state.upperRange}
                      onClick={() => { this.onSearchRange(); }}
                    >
                      <em className="fa fa-search" />
                    </Button>
                    <Button
                      bsStyle="success"
                      type="button"
                      href={excelUrl}
                    // disabled={(!salesOrderIds || salesOrderIds.length < 1)}
                    >
                      <em className="fa fa-download" />
                      <Translate value="excel" />
                    </Button>
                    <div style={{ float: 'left', marginLeft: '5px' }}>
                      <span style={{ fontSize: '14px', marginLeft: '25px' }}>Qty:</span>
                      <input
                        style={{ width: '50px', marginLeft: '5px', borderRadius: '5px', padding: '2px', border: '1px solid black' }}
                        type="text"
                        onChange={e => { this.onChangeQty(e); }}
                        // onKeyPress={e => { this.onKeyPressQuickEntry(e); }}
                        value={this.state.printQty}
                      />
                    </div>
                    <div style={{ float: 'left', marginLeft: '5px' }}>
                      <span style={{ fontSize: '14px', marginLeft: '5px', marginRight: '3px' }}>Price:</span>
                      <input
                        type="checkbox"
                        name="HasPrice"
                        checked={this.state.printHasPrice}
                        onClick={() => {
                          this.handleCheckHasPrice();
                        }}
                      />
                    </div>
                    <Button
                      type="button"
                      bsStyle="primary"
                      className="textAlignStyle"
                      href={url10new}
                      disabled={!this.state.selectedRows || this.state.selectedRows.length < 1 || !this.state.printQty}
                    >
                      <em className="fa fa-print" /><Translate value="label_10" />
                    </Button>
                    <Button
                      type="button"
                      bsStyle="primary"
                      className="textAlignStyle"
                      href={url30new}
                      disabled={!this.state.selectedRows || this.state.selectedRows.length < 1 || !this.state.printQty}
                    >
                      <em className="fa fa-print" /><Translate value="label_30" />
                    </Button>
                  </ButtonToolbar>
                }

                {/* Inventory Table */}
                {this.renderTable()}
                {isGFD &&
                <Row>
                  <Col xs={12}>
                  <label className="row-count" style={{fontSize: '15px', marginTop: '3px'}}>
                    <Translate value="total_items" />
                    :&nbsp;
                    {!this.props.gfdLoading &&
                      <span className="font-color-orange" id="row-count-equation">
                        {this.state.rows && this.state.rows.length}
                      </span>
                    }
                    {this.props.gfdLoading &&
                      <span className="font-color-orange" id="row-count-equation">
                      Loading...
                      </span>
                    }
                  </label>
                  {/* <label className="row-count" style={{marginTop: '0px'}}>
                    <Translate value="selected_orders" />
                    :&nbsp;
                    <span className="font-color-orange" id="row-count-equation">
                      {selectedOrderCount}
                    </span>
                  </label> */}
                  </Col>
                </Row>
                }
              </Panel>
            </Col> {/* End Main Workspace */}
          </Row>
        </Grid>
      </ContentWrapper>
      //---------------
      // End HTML
      //---------------
    );
  }
}

export default Products;



// WEBPACK FOOTER //
// ./master/jsx/components/Products/products.jsx